import { SortDirection } from '@tanstack/react-table'
import { CgChevronDown, CgChevronUp } from 'react-icons/cg'

import { Box, BoxProps, HStack, Text } from '@chakra-ui/react'

const SORT_ICON_COLOR = '#000000'

interface HeaderCellIProps extends BoxProps {
  label?: string
  canSort?: boolean
  getIsSorted?: () => false | SortDirection
}

interface SortIndicatorIProps {
  canSort: boolean
  sortedDirection: false | SortDirection
}

const SortIndicator = ({ canSort, sortedDirection }: SortIndicatorIProps) => {
  if (!canSort) return null

  if (sortedDirection) {
    const icon =
      sortedDirection === 'asc' ? (
        <CgChevronUp color={SORT_ICON_COLOR} size='12px' />
      ) : (
        <CgChevronDown color={SORT_ICON_COLOR} size='12px' />
      )

    return (
      <Box
        alignItems='center'
        display='flex'
        justifyContent='center'
        minH='14px'
        minW='12px'
        pointerEvents='none'
      >
        {icon}
      </Box>
    )
  }

  return (
    <Box
      alignItems='center'
      display='flex'
      justifyContent='center'
      minH='14px'
      minW='12px'
      pointerEvents='none'
      sx={{
        opacity: 0,
        'th:hover &': {
          opacity: 1,
        },
      }}
    >
      <Box display='flex' flexDirection='column'>
        <CgChevronUp color={SORT_ICON_COLOR} size='10px' />
        <CgChevronDown color={SORT_ICON_COLOR} size='10px' />
      </Box>
    </Box>
  )
}

export const HeaderCell = ({
  label,
  canSort = false,
  getIsSorted,
  ...rest
}: HeaderCellIProps) => {
  const sortedDirection = getIsSorted?.() ?? false

  return (
    <HStack
      color='#000000'
      fontSize='14px'
      fontWeight='600'
      lineHeight='18px'
      {...rest}
    >
      {label && <Text>{label}</Text>}
      <SortIndicator canSort={canSort} sortedDirection={sortedDirection} />
    </HStack>
  )
}
